var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(!_vm.PAD_assistShow),expression:"!PAD_assistShow"}]}),_c('PAD_assist',{directives:[{name:"show",rawName:"v-show",value:(_vm.PAD_assistShow),expression:"PAD_assistShow"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }